export default "__VITE_ASSET__Be571h8$__"